import type { ReactNode } from "react";

import { Stack } from "./Layout";
import { Heading, Text } from "./Typography";

export interface EmptyStateProps {
  action?: ReactNode;
  /**
   * Optional. Omit it whenever the title, the table it replaces, and the CTA
   * already say everything — "Created agents will appear here." is not copy.
   * When present, keep it to one short sentence (UI-LAW §4d) and move the
   * mental model into `help`.
   */
  description?: ReactNode;
  /** A `HelpTip`, rendered beside the title. UI-LAW §4d. */
  help?: ReactNode;
  title: string;
}

export function EmptyState({
  action,
  description,
  help,
  title,
}: EmptyStateProps) {
  return (
    <Stack className="marker-empty-state" gap={3}>
      <span className="marker-empty-state__title-row">
        <Heading level={3}>{title}</Heading>
        {help}
      </span>
      {/* Rendered only when supplied: an always-on <Text> would occupy a grid
          track and leave a dangling gap above the CTA. Absent, the grid has
          one row fewer and the uniform gap carries the rhythm. */}
      {description ? (
        <Text className="marker-empty-state__description" variant="muted">
          {description}
        </Text>
      ) : null}
      {action ? <div>{action}</div> : null}
    </Stack>
  );
}
